import _ from "lodash";

export const Feature = {
    dashboard_paymentInfo: 1 << 0,
    dashboard_statements: 1 << 1,
    dashboard_statements_download: 1 << 2,
    dashboard_invoices_download: 1 << 3,
    dashboard_businessDetails: 1 << 4,
    dashboard_clearError: 1 << 5,
    dashboard_subscriptions: 1 << 6,
    users: 1 << 7,
    users_activity_log: 1 << 8,
    support: 1 << 9,
    makePayment: 1 << 10,
    subscriptions: 1 << 11,
    changePackage: 1 << 12
}

export default Feature;
